import React, { useState, useEffect, useCallback } from "react";
import { Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MixStyle, theme } from "../../../styles";
import styled from "styled-components";
import { Grid, BreadCrumbBox, Button, Section, Loading } from "../../../core";
import { GeneralInfo } from "./GeneralInfo";
import { Note } from "./Note";
import { Calculations } from "./Calculations";
import DispatchHistory from "../../../components/DispatchHistory";
import PaymentHistory from "../../../components/PaymentHistory";
import moment from "moment";
import { getContractWithContractId } from "../../../helper/utils/api/contract.js";
import { getDispatchesOfContract } from "../../../helper/utils/api/dispatch";
import DispatchModal from "../../../components/Modals/contract/dispatchModal";
import ClothReturnModal from "../../../components/Modals/contract/clothReturnModal";
import YarnIssuenceModal from "../../../components/Modals/yarnIssence";
import PaymentModal from "../../../components/Modals/contract/paymentModal";
import Statistic from "./Statistics";
import YarnHistory from "../../../components/YarnHistory";
import {
  getYarnReceived,
  getYarnReturn,
} from "../../../helper/utils/api/yarnIssuence";
import { getPayments } from "../../../redux/Action/payment";
import { getCompanyId } from "../../../helper/utils/companyId";
const { buttonBg } = theme;

const ButtonProps = {
  width: "143px",
  height: "30px",
  margin: "5px",
  bg: buttonBg.tertiary,
};

const StyledButton = styled(Button)`
  ${MixStyle.Link};
  color: white;
  justify-content: center;
`;

const StyledBreadCrumb = styled(BreadCrumbBox)`
  ${MixStyle.flexArround}
`;

const ContractInner = () => {
  let history = useHistory();
  const dispatchToAction = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [activeContract, setActiveContract] = useState({});
  const [dispatches, setDispatches] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalState, setModalState] = useState({
    dispatchModal: false,
    clothReturnModal: false,
    yarnIssuenceModal: false,
    paymentModal: false,
  });

  const [yarnIssuence, setYarnIssuence] = useState([]);
  const contractIdFromRoute = history.location.state;

  const getActiveContract = useCallback(async () => {
    if (!contractIdFromRoute) return;
    setIsLoading(true);
    try {
      let {
        data: { result },
      } = await getContractWithContractId(contractIdFromRoute);

      let newDeiliverySchedul = result[0].delieverySchedule.map(
        (deliverySchedule) => {
          let obj = {
            date: moment(deliverySchedule.date),
            meter: deliverySchedule.meter || "",
          };
          return obj;
        }
      );
      let newObj = {
        ...result[0],
        contractDate: moment(result[0].contractDate),
        delieverySchedule: newDeiliverySchedul,
      };
      setActiveContract(newObj);
    } catch (error) {
      console.log("error while geting active timecard", error);
    }
    setIsLoading(false);
  }, [contractIdFromRoute]);

  const getDispatchesOfCurrentContract = useCallback(async () => {
    if (!contractIdFromRoute) return;
    setIsLoading(true);
    try {
      let {
        data: { result },
      } = await getDispatchesOfContract({ contractId: contractIdFromRoute });

      setDispatches(result);
    } catch (error) {
      console.log("error while geting dispatches of current contract", error);
    }
    setIsLoading(false);
  }, [contractIdFromRoute]);

  const loadPayments = useCallback(() => {
    const companyId = getCompanyId();
    if (activeContract._id && companyId && token) {
      dispatchToAction(getPayments(activeContract._id, companyId, token));
    }
  }, [activeContract._id, token, dispatchToAction]);

  const getYarnDetails = useCallback(async () => {
    if (!activeContract._id) return;
    setIsLoading(true);
    try {
      let contractId = activeContract._id;
      let yarnReceived = await getYarnReceived({ contractId });
      let yarnReturn = await getYarnReturn({ contractId });

      setYarnIssuence([...yarnReceived.data.result, ...yarnReturn.data.result]);
    } catch (error) {
      console.log("error", error);
    }
    setIsLoading(false);
  }, [activeContract._id]);

  useEffect(() => {
    getActiveContract();
    getDispatchesOfCurrentContract();
  }, [getActiveContract, getDispatchesOfCurrentContract]);

  useEffect(() => {
    if (activeContract._id) {
      loadPayments();
    }
  }, [activeContract._id, loadPayments]);

  useEffect(() => {
    getYarnDetails();
  }, [getYarnDetails]);

  const openModalHandler = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const closeModalHandler = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  return (
    <React.Fragment>
      {isLoading ? <Loading /> : null}
      <Grid fluid>
        {console.log("activeContract", activeContract)}
        <StyledBreadCrumb tittle="Contarct Details" route="/contract-list">
          <Row type="flex" justify="center">
            <StyledButton
              {...ButtonProps}
              onClick={() => openModalHandler("paymentModal")}
              // onClick={() => clickHandler("add_payment")}
            >
              Add Payments
            </StyledButton>

            <StyledButton
              {...ButtonProps}
              onClick={() => openModalHandler("dispatchModal")}
              // onClick={() => clickHandler("dispatch")}
            >
              Dispatch
            </StyledButton>
            <StyledButton
              {...ButtonProps}
              onClick={() => openModalHandler("clothReturnModal")}
              // onClick={() => clickHandler("cloth return")}
            >
              Cloth Return
            </StyledButton>
            {activeContract.type === "conversion" && (
              <StyledButton
                {...ButtonProps}
                onClick={() => openModalHandler("yarnIssuenceModal")}
                // onClick={() => clickHandler("yarn issunece")}
              >
                Yarn Issuence
              </StyledButton>
            )}
          </Row>
        </StyledBreadCrumb>

        <Statistic contractType={activeContract.type} />

        <Row type="flex" justify="center" gutter={[16, 16]}>
          <Col xs={24}>
            <GeneralInfo contractInfo={activeContract} />
          </Col>
        </Row>

        {activeContract.type === "conversion" && (
          <Calculations activeContract={activeContract} />
        )}

        <Note
          description={activeContract.description || ""}
          contractType={activeContract.type || ""}
          contractId={activeContract._id || ""}
          contractNo={activeContract.contractNo || ""}
        />

        <Section className="mt-20" padding="20px">
          <PaymentHistory />
        </Section>

        {activeContract.type === "conversion" && yarnIssuence && (
          <Section className="mt-20" padding="20px">
            <YarnHistory yarnIssuence={yarnIssuence} />
          </Section>
        )}

        <Section className="mt-20" padding="20px">
          <DispatchHistory
            dispatches={dispatches}
            getDispatchesOfCurrentContract={getDispatchesOfCurrentContract}
          />
        </Section>
      </Grid>

      {modalState.paymentModal && (
        <PaymentModal
          contractDetails={activeContract}
          paymentModal={modalState.paymentModal}
          closeModal={closeModalHandler}
          refreshPayments={loadPayments}
        />
      )}
      {modalState.dispatchModal && (
        <DispatchModal
          contractDetails={activeContract}
          dispatchModal={modalState.dispatchModal}
          closeModal={closeModalHandler}
          getDispatchesOfCurrentContract={getDispatchesOfCurrentContract}
        />
      )}
      {modalState.clothReturnModal && (
        <ClothReturnModal
          contractDetails={activeContract}
          clothReturnModal={modalState.clothReturnModal}
          closeModal={closeModalHandler}
          dispatches={dispatches}
          getDispatchesOfCurrentContract={getDispatchesOfCurrentContract}
        />
      )}

      {modalState.yarnIssuenceModal && (
        <YarnIssuenceModal
          getYarnDetails={getYarnDetails}
          contractDetails={activeContract}
          yarnIssuenceModal={modalState.yarnIssuenceModal}
          closeModal={closeModalHandler}
        />
      )}
    </React.Fragment>
  );
};

export default ContractInner;
